import { useTranslation } from 'react-i18next';

import { Path } from 'enums';
import { usePermissions } from 'hooks';

import { CompensationPage } from './CompensationPage';

export const CompensationRequestPage = () => {
  const { t } = useTranslation();
  const permissions = usePermissions();

  return (
    <CompensationPage
      breadcrumbs={{
        mainBreadcrumbLink: `/${Path.Requests}`,
        mainBreadcrumbTitle: t('employeesRequests'),
      }}
      permissions={permissions}
    />
  );
};
